import React, { useMemo, useEffect } from "react";
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Button, Row, Col } from "react-bootstrap";

import { useModal } from "../../../../hooks/useModal";

import HelperMetiers360 from "../../../../services/HelpersMetiers360";
import {URLS} from '../../../../services/axios';

import ClientInfoTabComponent from "../ClientDetailTabs/ClientInfoTabComponent";
import ClientWhitelistTabComponent from "../ClientDetailTabs/ClientWhitelistTabComponent";
import ClientWebappTabComponent from "../ClientDetailTabs/ClientWebappTabComponent";
import ClientSubscriptionTabComponent from "../ClientDetailTabs/ClientSubscriptionTabComponent";
import ClientFormationTabComponent from "../ClientDetailTabs/ClientFormationTabComponent";
import ClientUserTabComponent from "../ClientDetailTabs/ClientUserTabComponent";
import ClientCRMDetailViewComponent from "../clientCRMDetailView/ClientCRMDetailViewcomponent";
import ClientGroupsTabComponent from "../ClientDetailTabs/ClientGroupsTabComponent";
import ClientInteractionsTabComponent from "../ClientDetailTabs/ClientInteractionsTabComponent/ClientInteractionsTabComponent";
import ClientAddressesTabComponent from "../ClientDetailTabs/ClientAddressesTabComponent.jsx";
import Loader from "../../../widgets/Loader.jsx";

import AuthorizationChecker from "../../../../services/AuthorizationChecker.js";
import { useNavigate } from "react-router-dom";
import ClientParenthoodTabComponent from "../ClientDetailTabs/ClientParenthoodTabComponent.jsx";
import useCustomGetStoreState from "../../../../hooks/useCustomGetStoreState.jsx";
import CardGroupMediaComponent from "../../../widgets/CardGroupMedia/CardGroupMediaComponent.jsx";
import ClientStatsTabComponent from "../ClientDetailTabs/ClientStatsTabComponent.jsx";
import ClientWebapp2TabComponent from "../ClientDetailTabs/ClientWebapp2TabComponent";
import CustomTabsWithParams from "../../../widgets/customTabs/CustomTabsWithParams.jsx";

const ClientDetailAdminViewComponent = (props) => {
    const { clientById, allClients } = props;
    const {apiData} = useStoreState(state => state.actionSlugs);
    const clientsSlugs = useStoreState(actions => actions.actionSlugs.actionSlugsDispatcher('clients'));
    const { allVideos, isFetchingAllVideos } = useCustomGetStoreState("videos");
    const { readOne: readOneVideo } = useStoreState(actions => actions.actionSlugs.actionSlugsDispatcher('videos'));

    const { isParent, client: clientUniqueId } = useStoreState(state => state.auth);
    const { getIsParent } = useStoreActions(state => state.auth);

    const { modalComponent, setModalShow, modalData, setModalData, setIsSending } = useModal();

    const downloadCSV = () => {
        const urlCSV = URLS.API_URL + apiData.URLs.getHeadsetActivityByCSV.url.replace('ClientID',clientById.uniqueId).replace('activityID','all');
        window.open(urlCSV);
    }

    const downloadwebappActiviyCSV = () => {
        const urlCSV = URLS.API_URL + apiData.URLs.getwebappActivityByCSV.url.replace('ClientID',clientById.uniqueId);
        window.open(urlCSV);
    }

    // Parenthood
    const navigate = useNavigate();
    const goToClient = (uniqueIdClient) => {
        navigate(clientsSlugs.readOne.replace(':uniqueId', uniqueIdClient))
    }

    const parent = useMemo(() => 
        allClients?.length > 0 && clientById?.clientParent && 
            allClients.find(client => client.uniqueId === clientById.clientParent)
    , [allClients, clientById]);

    const parentListComponent =  <div className="parent-list">
        <div>
            <strong><br />Parent :<br /></strong>
        </div>
        <div className="children-list-container">
            {parent
                ? <a href="#" onClick={() => goToClient(parent.uniqueId)}>{parent.clientName}</a>
                : "0"}
        </div>
    </div>;

    const childrenList = useMemo(() => 
        allClients?.length > 0 && clientById?.clientChildren.length > 0
            ? allClients
                .filter(client => clientById.clientChildren.includes(client.uniqueId))
                .sort((a, b) => {
                    if (a.clientName > b.clientName)
                        return 1;
                    if (a.clientName < b.clientName)
                        return -1;
                    return 0;
                })
                .map( child => {
                    return <a key={'child' + child.uniqueId} href="#" className="w-fit-content" onClick={() => goToClient(child.uniqueId)}>
                        {child.clientName}
                    </a>})
            : []
    , [allClients]);

    const childrenListComponent = <div className="children-list">
        <div>
            <strong><br />Liste des {childrenList.length > 0 && childrenList.length} enfants :<br /></strong>
        </div>
        <div className="children-list-container">
            {childrenList.length > 0 ? childrenList : "0"}
        </div>
    </div>;

    const producedVideos = useMemo(() => {
        return AuthorizationChecker.isAdmin()
            ? allVideos?.filter(video => video?.producers?.find(producer => producer.id == clientById.uniqueId))
            : []
    }, [allVideos]);

    useEffect(() => {
        if (isParent === null && !AuthorizationChecker.isAdmin()) {
            getIsParent();
        }
    }, []);

    const contentTabs = useMemo(() => {
        let tabs = [];
        if (AuthorizationChecker.isAdmin()) {
            tabs = [
                {
                    eventKey: "clientDetails",
                    title: "Informations",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientInfoTabComponent clientById={clientById} setModalData={setModalData} modalData={modalData}
                        setModalShow={setModalShow} setIsSending={setIsSending} parentListComponent={parentListComponent}
                        childrenListComponent={childrenListComponent} />
                },
                {
                    eventKey: "subscriptionTab",
                    title: "Abonnements & casques",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientSubscriptionTabComponent client={clientById} />
                },
                {
                    eventKey: "CRMTab",
                    title: "Client CRM",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientCRMDetailViewComponent client={clientById} linkToClientPage={false} />
                },
                ...(AuthorizationChecker.hasGetRightsForProp('clientsCRM', 'interactions') ? [{
                    eventKey: "interactions",
                    title: "Suivi",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientInteractionsTabComponent clientId={clientById.uniqueId} />
                }] : []),
                {
                    eventKey: "userTab",
                    title: "Utilisateur⋅rices",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientUserTabComponent setModalData={setModalData} setIsSending={setIsSending}
                        modalData={modalData} setModalShow={setModalShow} clientById={clientById} />
                },
                {
                    eventKey: "formationTab",
                    title: "Webinaires",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientFormationTabComponent client={clientById} />
                },
                {
                    eventKey: "webappLegacyTab",
                    title: "Webapp-v1",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientWebappTabComponent setModalData={setModalData} setIsSending={setIsSending}
                        modalData={modalData} setModalShow={setModalShow} />
                },
                {
                    eventKey: "webappTab",
                    title: "Webapp",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientWebapp2TabComponent setModalData={setModalData} setIsSending={setIsSending}
                        modalData={modalData} setModalShow={setModalShow} readOnly={true} />
                },
                {
                    eventKey: "whitelist",
                    title: "WhiteLists",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientWhitelistTabComponent setModalData={setModalData} setIsSending={setIsSending}
                        modalData={modalData} setModalShow={setModalShow} />
                },
                {
                    eventKey: "groupsTab",
                    title: "Groupes accessibles",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientGroupsTabComponent client={clientById} />
                }
            ];
            if (producedVideos.length > 0) {
                tabs.push({
                    eventKey: "producedVideosTab",
                    title: "Expériences immersives produites",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    transition: isFetchingAllVideos,
                    content: <CardGroupMediaComponent mediaType="video" mediaList={producedVideos} readOne={readOneVideo} isLink={true} />
                })
            }
            tabs.push({
                eventKey: "statsTab",
                title: "Statistiques",
                unmountOnExit: true,
                mountOnEnter: undefined,
                content: <ClientStatsTabComponent clientUniqueId={clientById?.uniqueId} />
            });
            if (clientById.clientChildren.length > 0) {
                tabs.splice(1, 0, {
                    eventKey: "clientParenthood",
                    title: "Réseau",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientParenthoodTabComponent clientById={clientById} allClients={allClients}
                        childrenListComponent={childrenListComponent} setModalData={setModalData} setIsSending={setIsSending}
                        modalData={modalData} setModalShow={setModalShow} />
                })
            }
        } else {
            tabs = [
                {
                    eventKey: "subscriptionTab",
                    title: "Abonnements & casques",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientSubscriptionTabComponent client={clientById} fromAccountPage={true} />
                },
                {
                    eventKey: "userTab",
                    title: "Utilisateur⋅rices",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientUserTabComponent setModalData={setModalData} setIsSending={setIsSending}
                        modalData={modalData} setModalShow={setModalShow} clientById={clientById} fromAccountPage={true} />
                }
            ]
            if (isParent) {
                tabs.splice(2, 0, {
                    eventKey: "adressTab",
                    title: "Coordonnées",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientAddressesTabComponent clientById={clientById} />
                });
                tabs.splice(4, 0, {
                    eventKey: "statsTab",
                    title: "Statistiques",
                    unmountOnExit: true,
                    mountOnEnter: undefined,
                    content: <ClientStatsTabComponent clientUniqueId={clientById?.uniqueId} />
                });
                if (clientUniqueId !== clientById?.uniqueId) {
                    tabs.splice(3, 0, {
                        eventKey: "webappTab",
                        title: "Webapp",
                        unmountOnExit: true,
                        mountOnEnter: undefined,
                        content: <ClientWebapp2TabComponent setModalData={setModalData} setIsSending={setIsSending}
                            modalData={modalData} setModalShow={setModalShow} readOnly={true} />
                    });
                }
            }
        }

        return tabs;
    }, [clientById, isParent, producedVideos])

    return (<>
    {AuthorizationChecker.isAdmin() && <>
        <Row className="mb-3">
            <Col>
                <p>
                    Créé le : {HelperMetiers360.getdisplayDateType(clientById.createdAt.date)}
                    &nbsp;&nbsp;-&nbsp;
                    Dernière mise à jour le : {HelperMetiers360.getdisplayDateType(clientById.updatedAt.date)}
                </p>
            </Col>
            <Col className="d-flex justify-content-end">
                <Button onClick={downloadCSV} className="me-3"><i className="fas fa-download"/> Activité casques</Button>
                <Button onClick={downloadwebappActiviyCSV}><i className="fas fa-download"/> Activité webapp</Button>
            </Col>
        </Row>
    </>}
        
        
        <Row>
            <Col>
                {!AuthorizationChecker.isAdmin() && isParent === null
                    ? <Loader />
                    : <CustomTabsWithParams
                        contentTabs={contentTabs}
                        defaultActiveTabId={AuthorizationChecker.isAdmin() ? 'clientDetails' : 'subscriptionTab'}
                        id="client-details-tab"
                        className={AuthorizationChecker.isAdmin() ? "d-flex justify-content-center mb-4" : "d-flex"}
                    />
                }
            </Col>
        </Row>
        {modalComponent} 
    </>);
}
export default ClientDetailAdminViewComponent;